import { render, staticRenderFns } from "./price_config.vue?vue&type=template&id=439e36a4&scoped=true"
import script from "./price_config.vue?vue&type=script&lang=js"
export * from "./price_config.vue?vue&type=script&lang=js"
import style0 from "./price_config.vue?vue&type=style&index=0&id=439e36a4&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.29_cache-loader@4.1.0_webpack@4.47.0__css-loader@3.6_s74suowdwcam3het7yodnr4dnu/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "439e36a4",
  null
  
)

export default component.exports